import React from 'react';
import { useTranslation } from 'react-i18next';
import { DAYS_MODEL, EMPTY_VALUES } from '../../../../../../Apis/functions';
import ResumeInfoCard from '../../../../../../components/ResumeInfoCard';
import NotInformation from '../../../../../../components/NotInformation';
import { DatePickerChip, HexagonArrowIcon, IconCalendarPerson, IconClockTable } from '../../../../../../components/buttons/IconButtons';
import CustomTooltip from "../../../../../../components/CustomTooltip";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SummaryAccessRightsCard = ({ workShiftsList, customizedList }) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('access_rights')}
            titleIcon={<HexagonArrowIcon width={24} height={24} />}
            icon={<IconCalendarPerson className='btn-icon-svg-24px mt-3' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='row'>
                    <div className='col-sm-12 col-md-6 pr-md-3 pl-0'>
                        <p className='font-color-general-950 ibl-font-w-600 fs-14px mb-3'>{t('workshift')}</p>
                        {workShiftsList?.length > 0 ? (
                            workShiftsList.map((shift, index) => (
                                <div key={index} className='col-12 px-0 mb-3'>
                                    <div className='w-100 d-flex align-items-center background-shades-50 border-radius-8px p-2'>
                                        <span className='fs-12px ibl-font-w-600 font-color-general-950'>
                                            {shift.name || EMPTY_VALUES.DEFAULT}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <NotInformation text={t('no_information')} card={true}/>
                        )}
                    </div>

                    <div className='col-sm-12 col-md-6 pl-0 pl-md-3 mt-4 mt-md-0'>
                        <p className='font-color-general-950 ibl-font-w-600 fs-14px mb-3'>{t('custom_shift')}</p>
                        {customizedList?.length > 0 ? (
                            <div className={"overflow-y-auto maxh-320px"}>
                                { customizedList.map((item, index) => (
                                    <div key={index} className='mb-2 mt-3'>
                                        <div className='background-shades-50 border-radius-8px px-2 py-2 row align-items-center mx-0'>
                                            <div className='col-4 overflow-hidden'>
                                                <CustomTooltip
                                                    text={`${item.zoneName || EMPTY_VALUES.DEFAULT}`}
                                                    classes={"fs-14px font-color-shades-950 ibl-font-w-500 text-ellipsis-1-row"}
                                                    showIfTruncated={true}
                                                    placement={"top"}
                                                />
                                            </div>
                                            <div className='col-4 d-flex align-items-center overflow-hidden'>
                                                <DatePickerChip className='mr-1 flex-shrink-0' />
                                                <CustomTooltip
                                                    text={`${t(DAYS_MODEL.find((d) => d.value === item.dayId)?.key) || EMPTY_VALUES.DEFAULT}`}
                                                    classes={"fs-12px font-color-shades-800 ibl-font-w-300 text-ellipsis-1-row"}
                                                    showIfTruncated={true}
                                                    placement={"top"}
                                                />
                                            </div>
                                            <div className='col-4 d-flex align-items-center overflow-hidden'>
                                                <IconClockTable className='mr-1 flex-shrink-0' />
                                                <CustomTooltip
                                                    text={`${item.from || EMPTY_VALUES.DEFAULT} ${t('to')?.toLowerCase()} ${item.to || EMPTY_VALUES.DEFAULT}`}
                                                    classes={"fs-12px font-color-shades-800 ibl-font-w-300 text-ellipsis-1-row"}
                                                    showIfTruncated={true}
                                                    placement={"top"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                        ) : (
                            <NotInformation text={t('no_information')} card={true} />
                        )}
                    </div>
                </div>
            }
        />
    );
};

export default SummaryAccessRightsCard;
